import { Controller } from "@hotwired/stimulus"

// Error pages: primary recovery reloads/retries the page that failed.
// Web: intercept popstate so the browser back button does not re-enter a broken screen.
export default class extends Controller {
  static values = {
    homeUrl: String,
    retryUrl: String
  }

  connect () {
    this.boundPopState = this.onPopState.bind(this)
    history.pushState({ errorBarrier: true }, "", location.href)
    window.addEventListener("popstate", this.boundPopState)
  }

  disconnect () {
    window.removeEventListener("popstate", this.boundPopState)
  }

  onPopState () {
    this.visitHome()
  }

  refresh (event) {
    event.preventDefault()
    this.reloadCurrent()
  }

  goHome (event) {
    event.preventDefault()
    this.visitHome()
  }

  reloadCurrent () {
    const retryUrl = this.retryUrlValue
    const onErrorRoute = /^\/(?:404|422|500)(?:\?|$)/.test(window.location.pathname)

    // If the webview is still on /404|/422|/500, navigate to the original failed path.
    if (onErrorRoute && retryUrl && retryUrl !== window.location.pathname + window.location.search) {
      window.location.replace(retryUrl)
      return
    }

    // Same URL as the failed visit: hard reload (avoids Turbo showing the cached error doc).
    window.location.reload()
  }

  visitHome () {
    const url = this.homeUrlValue
    if (!url) return

    if (window.Turbo) {
      Turbo.visit(url, { action: "replace" })
    } else {
      window.location.replace(url)
    }
  }
}
